import React, { useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "./navbar";
import Footer from "../components/Footer";

// Importing images
import MaasaiMaraImage from "../assets/af3.jpg";
import NairobiNationalParkImage from "../assets/af6.jpg";
import DianiBeachImage from "../assets/des2.jpg";
import MountKenyaImage from "../assets/mount kenya.jpg";
import AmboImage from "../assets/af5.webp";
import TsavoImage from "../assets/tsavo.jpg";
import LamuImage from "../assets/lamu.jpg";
import GateImage from "../assets/helsgate.jpg";
import LakenakuruImage from "../assets/af11.jpg";
import SerengetiNationalParkImage from "../assets/af7.jpg";
import ZanzibarImage from "../assets/10.jpg";
import MeruImage from "../assets/meru.jpg";
import SamburuImage from "../assets/samburu.jpg";
import MountKilimanjaroImage from "../assets/af4.jpg";
import HeroBannerImage from "../assets/af1.webp";


const destinations = [
  {
    country: "Kenya",
    description:
      "Kenya is renowned for its stunning landscapes, diverse wildlife, and vibrant culture. Explore iconic safaris, breathtaking mountains, and pristine beaches.",
    places: [
      {
        name: "Maasai Mara",
        description: "Famous for the Great Migration and the Big Five, Maasai Mara is a world-class safari destination.",
        activities: ["Safari", "Hot Air Balloon Ride", "Photography", "Nature Walk"],
        image: MaasaiMaraImage,
      },
      {
        name: "Nairobi National Park",
        description: "A unique park located just outside the city, offering incredible wildlife experiences with a city skyline in the background.",
        activities: ["Safari", "Photography", "Birdwatching"],
        image: NairobiNationalParkImage,
      },
      {
        name: "Diani Beach",
        description: "Relax on the white sands of Diani Beach, known for its crystal-clear waters and vibrant marine life.",
        activities: ["Snorkeling", "Scuba Diving", "Beach Volleyball", "Water Sports"],
        image: DianiBeachImage,
      },
      {
        name: "Mount Kenya",
        description: "Kenya’s highest mountain and a UNESCO World Heritage Site, ideal for trekkers and climbers seeking alpine adventure.",
        activities: ["Trekking", "Camping", "Photography"],
        image: MountKenyaImage,
      },
      {
        name: "Lake Nakuru",
        description: "Famous for its large flocks of flamingos and endangered rhinos, this lake is a haven for bird lovers and wildlife enthusiasts.",
        activities: ["Safari", "Bird Watching", "Nature Walk"],
        image: LakenakuruImage,
      },
      {
        name: "Amboseli National Park",
        description: "Known for its large elephant herds and stunning views of Mount Kilimanjaro across the border in Tanzania.",
        activities: ["Safari", "Photography", "Wildlife Watching"],
        image: AmboImage,
      },
      {
        name: "Lamu Island",
        description: "A charming Swahili coastal town with ancient architecture, donkeys for transport, and a serene, laid-back beach culture.",
        activities: ["Snorkeling", "Scuba Diving", "Beach Relaxation"],
        image: LamuImage,
      },
      {
        name: "Tsavo National Park",
        description: "One of the largest parks in Africa, known for its red elephants, lava flows, and rugged wilderness.",
        activities: ["Safari", "Camping", "Wildlife Photography"],
        image: TsavoImage,
      },
      {
        name: "Hell's Gate National Park",
        description: "Popular for hiking, rock climbing, and cycling among dramatic cliffs and geothermal activity.",
        activities: ["Hiking", "Cycling", "Nature Walk"],
        image: GateImage,
      },
      {
        name: "Samburu National Reserve",
        description: "A semi-arid park known for its unique wildlife species such as the Grevy's zebra and Somali ostrich.",
        activities: ["Safari", "Photography", "Wildlife Watching"],
        image: SamburuImage,
      },
      {
        name: "Meru National Park",
        description: "A lush park made famous by the story of Elsa the lioness, offering a mix of rivers, forests, and wildlife.",
        activities: ["Safari", "Bird Watching", "Nature Walk"],
        image: MeruImage,
      },
    
    ],
  },
  {
    country: "Tanzania",
    description:
      "Tanzania is home to some of Africa's most famous wildlife destinations, including the Serengeti and Kilimanjaro. It offers an unforgettable adventure for nature lovers.",
    places: [
      {
        name: "Serengeti National Park",
        description: "Renowned for its vast savannahs, Serengeti is the perfect place to witness the annual wildebeest migration.",
        activities: ["Safari", "Camping", "Wildlife Photography", "Bird Watching"],
        image: SerengetiNationalParkImage,
      },
      {
        name: "Zanzibar",
        description: "A tropical paradise known for its stunning beaches, rich history, and spice plantations.",
        activities: ["Beach Relaxation", "Historical Tours", "Spice Farm Visit", "Island Hopping"],
        image: ZanzibarImage,
      },
      {
        name: "Mount Kilimanjaro",
        description: "Climb the tallest mountain in Africa and experience breathtaking views from its summit.",
        activities: ["Trekking", "Camping", "Cultural Tours", "Photography"],
        image: MountKilimanjaroImage,
      },
    ],
  },
];

const DestinationPage = () => {
  const [selectedCountry, setSelectedCountry] = useState("Kenya");
  const selectedData = destinations.find((d) => d.country === selectedCountry);

  const handleMouseEnter = () => {
    // Optional: Add hover effect like changing style or logging
  };

  const handleMouseLeave = () => {
    // Optional: Reset style or other behavior
  };

  return (
    <div style={{ fontFamily: "Arial, sans-serif", backgroundColor: "#fff" }}>
      <Navbar />
      <div style={styles.floatingCTA}>
  <a
    href="https://mail.google.com/mail/?view=cm&fs=1&to=wangotrailsafaris@gmail.com&su=Booking%20Inquiry&body=Hi,%0D%0A%0D%0AI%20want%20to%20book%20assist%20me"
    style={styles.ctaButton}
    onMouseEnter={handleMouseEnter}
    onMouseLeave={handleMouseLeave}
    target="_blank"
    rel="noopener noreferrer"
  >
    Book Your Tour
  </a>
</div>
      
      {/* Hero Banner */}
      <section style={{ ...styles.hero, backgroundImage: `url(${HeroBannerImage})` }}>
        <div style={styles.overlay}>
          <h1 style={styles.heroText}>Explore the Wonders of Kenya & Tanzania</h1>
          <p style={styles.heroSub}>Wildlife, Mountains, Beaches, and Adventure</p>
          <a
            href="https://wa.me/+254706019613?text=Hi%2C%20I%20would%20like%20to%20enquire%20about%20a%20tour%20package."
            style={styles.heroButton}
            target="_blank"
            rel="noopener noreferrer"
          >
            Enquire
          </a>
        </div>
      </section>

      {/* Tabs */}
      <div style={styles.tabContainer}>
        {destinations.map((dest) => (
          <button
            key={dest.country}
            onClick={() => setSelectedCountry(dest.country)}
            style={{
              ...styles.tabButton,
              backgroundColor: selectedCountry === dest.country ? "#ff9900" : "#ddd",
              color: selectedCountry === dest.country ? "#fff" : "#333",
            }}
          >
            {dest.country}
          </button>
        ))}
      </div>

      {/* Destination Cards with Scrolling */}
      <section style={styles.section}>
        <h2 style={styles.heading}>Explore {selectedData.country}</h2>
        <p style={styles.subText}>{selectedData.description}</p>

        <div style={styles.scrollContainer}>
          {selectedData.places.map((destination, index) => (
            <div key={index} style={styles.card}>
              <img src={destination.image} alt={destination.name} style={styles.cardImage} />
              <h3>{destination.name}</h3>
              <p>{destination.description}</p>
              <p>
                <strong>Activities:</strong> {destination.activities.join(", ")}
              </p>
            </div>
          ))}
        </div>
      </section>
      <section style={styles.ctaSection}>
      <h2 style={styles.ctaTitle}>Start Your East African Journey</h2>
     
    </section>

      <Footer />
    </div>
  );
};

const styles = {
  hero: {
    backgroundSize: "cover",
    backgroundPosition: "center",
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#fff",
    textAlign: "center",
    position: "relative",
  },
  overlay: {
  },
  heroText: {
  fontSize: "3rem",
  fontWeight: "bold",
  },
  heroSub: {
  fontSize: "1.5rem",
  margin: "10px 0",
  },
  heroButton: {
  backgroundColor: "#ff9900",
  color: "#fff",
  padding: "10px 20px",
  textDecoration: "none",
  borderRadius: "5px",
  fontSize: "1rem",
  },
  tabContainer: {
  display: "flex",
  justifyContent: "center",
  margin: "20px 0",
  },
  tabButton: {
  padding: "10px 20px",
  border: "1px solid #ddd",
  cursor: "pointer",
  margin: "0 10px",
  borderRadius: "5px",
  fontSize: "1rem",
  },
  section: {
  padding: "20px",
  },
  heading: {
  fontSize: "2.5rem",
  fontWeight: "bold",
  textAlign: "center",
  margin: "20px 0",
  },
  subText: {
  fontSize: "1.2rem",
  textAlign: "center",
  margin: "20px 0",
  },
  scrollContainer: {
  display: "flex",
  overflowX: "scroll",
  gap: "20px",
  paddingBottom: "20px",
  },
  card: {
  minWidth: "300px",
  backgroundColor: "#fff",
  borderRadius: "10px",
  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
  padding: "15px",
  textAlign: "center",
  flexShrink: 0,
  },
  cardImage: {
  width: "100%",
  borderRadius: "10px",
  height: "200px",
  objectFit: "cover",
  },
  ctaSection: {
    backgroundColor: "#003366",
    color: "#fff",
    padding: "60px 20px",
    textAlign: "center",
  },
  ctaTitle: {
    fontSize: "2rem",
    marginBottom: "20px",
  },

  floatingCTA: {
    position: "fixed",
    bottom: "20px",
    right: "20px",
    zIndex: 1000,
  },
  ctaButton: {
  backgroundColor: "#ff9900",
  color: "#fff",
  padding: "15px 30px",
  fontSize: "1rem",
  borderRadius: "30px",
  textDecoration: "none",
  boxShadow: "0 5px 15px rgba(0, 0, 0, 0.1)",
  },
  };
  
  export default DestinationPage;